import { Overline } from "@/components/site/Primitives";

export default function Legal({ title, updated, sections }) {
  return (
    <div data-testid="legal-page">
      <section className="max-w-3xl mx-auto px-6 pt-24 pb-10">
        <Overline>Rosewood Cottage</Overline>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light mt-4 mb-3 leading-tight">{title}</h1>
        <p className="font-sans text-xs uppercase tracking-[0.14em] text-brand-muted">Last updated {updated}</p>
      </section>
      <section className="max-w-3xl mx-auto px-6 pb-24">
        {sections.map(([h, body], i) => (
          <div key={i} className="mb-10">
            <h2 className="font-serif text-2xl mb-3">{h}</h2>
            <p className="font-body text-brand-body text-lg leading-relaxed whitespace-pre-line">{body}</p>
          </div>
        ))}
      </section>
    </div>
  );
}

export const PRIVACY = {
  title: "Privacy Policy", updated: "June 2026",
  sections: [
    ["What we collect", "When you subscribe to our newsletter or make a purchase, we collect your name and email address, and — for orders — payment details processed securely by Stripe. We never see or store your card details."],
    ["How we use it", "We use your information to deliver your digital purchases, send the newsletter you have asked for, and reply to your messages. That is all. We do not sell or share your details with anyone."],
    ["Email marketing", "Our newsletter is managed through Klaviyo. You may unsubscribe at any moment using the link at the foot of every letter."],
    ["Cookies", "We use only the essential cookies needed for the website to work and to keep your admin session secure."],
    ["Your rights", "You may ask us at any time to see, correct or delete the information we hold about you. Simply write to us via the Contact page."],
  ],
};

export const TERMS = {
  title: "Terms of Service", updated: "June 2026",
  sections: [
    ["A gentle agreement", "By using this website and purchasing our digital products, you agree to these terms. We have kept them simple and fair."],
    ["Our products", "All products sold here are digital goods (PDF books and journals), delivered instantly upon purchase. They are for your personal use only."],
    ["Copyright", "Every word, recipe and illustration is the original work of Agnes Whitmore. You may print and enjoy your purchase at home, but please do not resell, redistribute or share the files."],
    ["Pricing", "All prices are shown in US dollars. We reserve the right to change prices, but any purchase you have already made is honoured at the price you paid."],
    ["Availability", "We aim to keep the website running smoothly, but cannot promise it will always be available without interruption."],
  ],
};

export const REFUND = {
  title: "Refund Policy", updated: "June 2026",
  sections: [
    ["Digital goods", "Because our products are digital and delivered instantly, they cannot be returned, and purchases are generally non-refundable."],
    ["But we care", "That said, your happiness matters more to us than any single sale. If your purchase failed to download, arrived faulty, or was bought in genuine error, do write to us within 14 days and we shall put it right — with a repair, a replacement, or a refund where fair."],
    ["How to reach us", "Please use the Contact page and include your order details. Every message is read personally, and answered with care."],
    ["Payment disputes", "If you believe you have been charged in error, please contact us first. We can almost always resolve things more quickly and kindly than a formal dispute."],
  ],
};
